import { env } from '@/env';

/**
 * La sezione QChinesePoker e' accesa in questa build? (`VITE_FEATURE_CP_ENABLED`, OPT-IN: `=== 'true'`.)
 * 🔴 UN predicato: lo leggono le rotte (`routes/router.tsx`), la Hub (`HubSections`) e il selettore dei giochi
 * (`useGameSelection`), e nessun altro. Tre copie divergerebbero, e il selettore offrirebbe un gioco senza rotte. Il ruolo
 * `beta` non si ricontrolla qui: lo chiedono le rotte (`RoleGate`), la Hub e il selettore, come per il backgammon.
 * ⛔ Spento OVUNQUE in T0, `.env.staging` compreso: gli host di QCP (`env.ts`) sono quelli di PRODUZIONE per default, quindi
 * un flag acceso su stg-tma parlerebbe al QCP di produzione (I-270). Si accende in T2, nella stessa PR che porta gli host di
 * staging (`tools/verify-qcp.ts`).
 */
export function qcpAcceso(): boolean {
  return env.featureChinesePokerEnabled;
}
